import { render, staticRenderFns } from "./RankingLikes.vue?vue&type=template&id=0b228d57&scoped=true&lang=pug&"
import script from "./RankingLikes.vue?vue&type=script&lang=ts&"
export * from "./RankingLikes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b228d57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/arc-one/_www/millsta-ready/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b228d57')) {
      api.createRecord('0b228d57', component.options)
    } else {
      api.reload('0b228d57', component.options)
    }
    module.hot.accept("./RankingLikes.vue?vue&type=template&id=0b228d57&scoped=true&lang=pug&", function () {
      api.rerender('0b228d57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/templates/RankingLikes.vue"
export default component.exports